import { ErrorHandler, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import posthog from 'posthog-js';

function tryToUnwrapZonejsError(error: unknown): unknown {
  const ng = error as { ngOriginalError?: unknown } | null;
  return ng?.ngOriginalError != null ? ng.ngOriginalError : error;
}

function isErrorOrErrorLikeObject(value: unknown): value is Error {
  if (value instanceof Error) {
    return true;
  }
  if (value === null || typeof value !== 'object' || Array.isArray(value)) {
    return false;
  }
  return (
    'name' in value && 'message' in value && 'stack' in value
  );
}

function extractHttpModuleError(error: HttpErrorResponse): string | Error {
  if (isErrorOrErrorLikeObject(error.error)) {
    return error.error;
  }
  if (
    typeof ErrorEvent !== 'undefined' &&
    error.error instanceof ErrorEvent &&
    error.error.message
  ) {
    return error.error.message;
  }
  if (typeof error.error === 'string') {
    return `Server returned code ${error.status} with body "${error.error}"`;
  }
  return error.message;
}

function extractError(errorCandidate: unknown): unknown {
  const error = tryToUnwrapZonejsError(errorCandidate);
  if (error instanceof HttpErrorResponse) {
    return extractHttpModuleError(error);
  }
  if (typeof error === 'string' || isErrorOrErrorLikeObject(error)) {
    return error;
  }
  return null;
}

@Injectable()
export class PosthogErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    console.error(error);
    const extracted = extractError(error);
    if (extracted == null) {
      return;
    }
    posthog.captureException(extracted);
  }
}
